import * as React from "react";
import NavigationSiteLogo, {
    INavigationSiteLogoProps
} from "~/components/navigation/navigation-site-logo/navigation-site-logo";
import NavigationPrimaryLinks, {
    INavigationPrimaryLinksProps
} from "~/components/navigation/navigation-primary-links/navigation-primary-links";
import classNames from "classnames";
// import NavigationProfile, {
//     INavigationProfileProps
// } from "~/components/navigation/navigation-profile/navigation-profile";
// import LoginFormContainer, { ILoginFormContainerProps } from "../login-form-container/login-form-container";
// import NavigationMiniBasket, {
//     INavigationMiniBasketProps
// } from "./navigation-mini-basket/navigation-mini-basket";
// import BasketCount, { IBasketCountProps } from "../basket-count/basket-count";
import NavigationSearch, { INavigationSearchProps } from "./navigation-search/navigation-search";
import AnimateHeight from "react-animate-height";
import NavigationGlobalSites, {
    NavigationGlobalSitesProps
} from "./navigation-global-sites/navigation-global-sites";
import { toggleBodyClass } from "~/utils/body-class-util";

export interface INavigationProps {
    navigationGlobalSitesConfig?: NavigationGlobalSitesProps;
    navigationSiteLogoConfig?: INavigationSiteLogoProps;
    navigationPrimaryLinksConfig?: INavigationPrimaryLinksProps;
    // navigationProfileConfig?: INavigationProfileProps;
    navigationSearchConfig?: INavigationSearchProps;
    navigationSearchOverlayConfig?: {
        title: string;
        inputTitle: string;
        searchText: string;
        suggestions: string[];
    };
    // navigationMiniBasketConfig?: INavigationMiniBasketProps;
    // loginFormConfig?: ILoginFormContainerProps;
    // basketCount: IBasketCountProps["count"];
    // isLoggedIn: boolean;
}

export interface INavigationState {
    drawerIsOpen: boolean;
    globalSitesNavigationIsOpen: boolean;
}

class Navigation extends React.Component<INavigationProps, INavigationState> {
    private drawer: HTMLDivElement | null;
    public state: INavigationState = {
        drawerIsOpen: false,
        globalSitesNavigationIsOpen: false
    };

    public componentDidMount() {
        document.addEventListener("click", (event: MouseEvent) => this.handleClick(event));
    }

    public componentWillUnmount() {
        document.removeEventListener("click", (event: MouseEvent) => this.handleClick(event));
    }

    private setBodyOverlay(toggleOn: boolean) {
        toggleBodyClass("body--navigationOverlayOpen", toggleOn);
    }

    private toggleDrawer = (setValue?: boolean) => {
        const setStateToOpen = setValue !== undefined ? setValue : !this.state.drawerIsOpen;
        if (this.state.globalSitesNavigationIsOpen) {
            this.toggleGlobalSitesNavigation(false);
        }
        this.setBodyOverlay(setStateToOpen);
        this.setState({ drawerIsOpen: setStateToOpen });
    };
    private toggleGlobalSitesNavigation = (setValue?: boolean) => {
        const setStateToOpen = setValue !== undefined ? setValue : !this.state.globalSitesNavigationIsOpen;
        if (this.state.drawerIsOpen) {
            this.toggleDrawer(false);
        }
        this.setBodyOverlay(setStateToOpen);
        this.setState({
            globalSitesNavigationIsOpen: setStateToOpen
        });
    };

    private handleClick(event: MouseEvent) {
        if (!this.state.drawerIsOpen && !this.state.globalSitesNavigationIsOpen) {
            return;
        }
        const drawerDomNode = this.drawer;

        if (!drawerDomNode || (event.target && !drawerDomNode.contains(event.target as Node))) {
            this.toggleDrawer(false);
            this.toggleGlobalSitesNavigation(false);
        }
    }

    public render() {
        const {
            navigationGlobalSitesConfig,
            navigationSiteLogoConfig,
            navigationPrimaryLinksConfig,
            // navigationProfileConfig,
            // navigationMiniBasketConfig,
            navigationSearchConfig,
            navigationSearchOverlayConfig
            // loginFormConfig,
            // isLoggedIn
        } = this.props;

        const navigationClasses = classNames("navigation", {
            "navigation--site-logo-only":
                navigationSiteLogoConfig &&
                !(
                    navigationGlobalSitesConfig ||
                    navigationPrimaryLinksConfig ||
                    // navigationProfileConfig ||
                    // navigationMiniBasketConfig ||
                    navigationSearchConfig
                )
        });
        const navigationLinksClasses = classNames("navigation-links", {
            "navigation-links--open": this.state.drawerIsOpen
        });
        const navigationButtonClasses = classNames("navigation-burger-button__icon", {
            "navigation-burger-button__icon--isOpen": this.state.drawerIsOpen
        });
        // const basketCountClasses = classNames("navigation__basket-count", {
        //     "navigation__basket-count--drawerIsOpen": this.state.drawerIsOpen
        // });

        const hasAnyNavigation = !!(
            navigationPrimaryLinksConfig
            // navigationProfileConfig ||
            // loginFormConfig
        );

        return (
            <div className="navigation-wrapper" ref={node => (this.drawer = node)}>
                {navigationGlobalSitesConfig && (
                    <div className="navigation-global-sites-wrapper">
                        <AnimateHeight
                            className="accordion-rah-content"
                            contentClassName="navigation-global-sites-rah"
                            duration={300}
                            applyInlineTransitions={false}
                            height={this.state.globalSitesNavigationIsOpen ? "auto" : 0}
                        >
                            <NavigationGlobalSites {...navigationGlobalSitesConfig} />
                        </AnimateHeight>
                    </div>
                )}
                <nav className={navigationClasses} role="navigation" aria-label="navigation">
                    <div className="navigation__inner">
                        {hasAnyNavigation && (
                            <button
                                className="navigation-burger-button"
                                type="button"
                                onClick={() => this.toggleDrawer()}
                            >
                                <div className={navigationButtonClasses}>
                                    <span />
                                    <span />
                                    <span />
                                </div>
                                {/* <BasketCount className={basketCountClasses} count={this.props.basketCount} /> */}
                            </button>
                        )}

                        <div className="navigation-site-logo">
                            {navigationGlobalSitesConfig && (
                                <button
                                    className={classNames("navigation-global-sites-button reset-button", {
                                        "navigation-global-sites-button--isOpen": this.state
                                            .globalSitesNavigationIsOpen
                                    })}
                                    type="button"
                                    onClick={() => this.toggleGlobalSitesNavigation()}
                                >
                                    <span />
                                    <span />
                                </button>
                            )}

                            {navigationSiteLogoConfig && <NavigationSiteLogo {...navigationSiteLogoConfig} />}
                        </div>
                        {navigationSearchConfig && (
                            <NavigationSearch visibility="mobile" {...navigationSearchConfig} />
                        )}

                        {hasAnyNavigation && (
                            <div className={navigationLinksClasses}>
                                {/* {navigationProfileConfig && (
                                    <NavigationProfile {...navigationProfileConfig} isLoggedIn={isLoggedIn}>
                                        {loginFormConfig && <LoginFormContainer {...loginFormConfig} />}
                                    </NavigationProfile>
                                )}
                                {navigationMiniBasketConfig && (
                                    <NavigationMiniBasket
                                        {...navigationMiniBasketConfig}
                                        basketCount={this.props.basketCount}
                                    />
                                )} */}
                                {navigationSearchConfig && (
                                    <NavigationSearch visibility="desktop" {...navigationSearchConfig} />
                                )}
                                {navigationPrimaryLinksConfig && (
                                    <NavigationPrimaryLinks {...navigationPrimaryLinksConfig} />
                                )}
                            </div>
                        )}
                    </div>
                    <div className="cludo-nav-search" id="cludo-nav-search" aria-hidden="true">
                        <button
                            className="cludo-nav-search__close"
                            onClick={event => window.toggeNavigationSearch(event)}
                            aria-label="Luk overlay"
                        >
                            <span></span>
                            <span></span>
                        </button>
                        <div className="cludo-nav-search__inner">
                            <h2>{navigationSearchOverlayConfig?.title}</h2>
                            <form
                                className="cludo-nav-search__form"
                                role="search"
                                action="javascript:void(0)"
                            >
                                <input
                                    className="cludo-nav-search__input"
                                    title={navigationSearchOverlayConfig?.inputTitle}
                                    name="searchrequest"
                                    type="search"
                                    autoComplete="off"
                                    placeholder={navigationSearchOverlayConfig?.inputTitle}
                                    aria-autocomplete="list"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                />
                                <button
                                    type="submit"
                                    title={navigationSearchOverlayConfig?.searchText}
                                    className="cludo-nav-search__button"
                                    aria-label={navigationSearchOverlayConfig?.searchText}
                                ></button>
                            </form>
                        </div>
                        <div className="cludo-nav-search__suggestions">
                            <div className="cludo-nav-search__suggestions-container">
                                {navigationSearchOverlayConfig?.suggestions.map(suggestion => {
                                    return (
                                        <button
                                            type="button"
                                            key={suggestion}
                                            className="cludo-nav-search__suggestion"
                                            onClick={event => window.searchOn(event)}
                                        >
                                            {suggestion}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        );
    }
}

export default Navigation;
